import React, { FC } from 'react';
import cx from 'classnames';

import { Button } from 'components/UI';

import styles from './heroText.module.scss';

interface IProps {
  title: JSX.Element | string;
  text?: JSX.Element | string;
  actionLabel?: string;
  actionLink?: string;
  className?: string;
}

const HeroText: FC<IProps> = ({
  title,
  text,
  actionLabel,
  actionLink,
  className,
}) => (
  <div className={cx(styles.container, className)}>
    <h1 className={styles.title}>{title}</h1>
    {!!text && (
      <p className={styles.text}>{text}</p>
    )}
    {!!actionLabel && (
      <Button className={styles.button} link={actionLink}>
        {actionLabel}
      </Button>
    )}
  </div>
);

export default HeroText;
